export enum GoToPageTypes  {
    BEGINING,
    NEXT,
    PREVIOUS,
    CERTAIN,
}